/** 
  * @class Image Resource Class for Background Images
  * @extends SSImageResource
  * @param {Object} config An options hash with settings for the Resource
  */
import SSImageResource from './001-slideshare_image_resource';

function SSBgImageResource(config){
  this.resourceTemplate = {
    prefix: config.baseUrl,
    digitLength: 3,
    cacheable: true,
    retries : 0,
    isCritical: true
  };
  this.useTimeStamp = true;
  // save size>quality maps for best size fit calculations
  var imageVersions = config.availableSizes;
  
  this.imageVersions = [];
  for (var width in imageVersions){
    this.imageVersions[parseInt(width,10)] = imageVersions[width];
  }

  if(config.is_private){
    this.useTimeStamp = false;
    this._generateUrl = this._generatePrivateUrl;
  }else{
    this._generateUrl = this._generateUrl;
  }
  
  SSImageResource.call(this,config);  
  
}

SSBgImageResource.prototype = new SSImageResource();

SSBgImageResource.prototype._generateUrl = function(index, size, quality){
  return this.config.baseUrl + 'images/' + parseInt(quality,10) + 
    '/slide-' + index + '-' + size + '.jpg?cb=' + this.config.timestamp;
};


SSBgImageResource.prototype._generatePrivateUrl = function(index, size, quality){  
  return this.config.baseUrl + 'images%2F' + parseInt(quality,10) + '%2Fslide-' + index + '-' + size +
   '.jpg' + this.config.privateImageSignatures[size][quality].url;
};




/**
  * Gets the a list of widths and their suffixes, ie the different versions available
  * @private
  * @return {Object} Returns a list of width, version object pairs
  */
SSBgImageResource.prototype._getSuffixes = function(){
  var suffixes = {};
  var imageVersions = this.imageVersions;
  var urlSuffix = this.config.timestamp ;
  // fullscreen size if available in hash, else find highest image size and add that

  
  var i, width, qualities_or_extensions, versionLen, quality, suffix;
  for (width in imageVersions){
    if (!imageVersions.hasOwnProperty(width)){
      continue;
    }
    
    width = parseInt(width, 10);
    
    // v1 conversion holds single image extension in array
    // v2 conversion holds multiple image qualities in array
    qualities_or_extensions = imageVersions[width];
    suffixes[width] = [];
    versionLen = qualities_or_extensions.length;
    for (i=0; i<versionLen; i++){
      quality = parseInt(qualities_or_extensions[i],10); // quality will be NaN for v2 conversion
        
      suffix = {
        url : this._generateUrl(this.indexString, width, qualities_or_extensions[i]),
        status : 'initialized',
        retries : 2        
      };
      suffixes[width][(isNaN(quality) ? 75 : quality)] = suffix;
    }
  }
  return suffixes;
};

export default SSBgImageResource;
